import { z } from 'zod';
/**
 * A PIN as transmitted over the wire: exactly 6 digits, string-typed so a
 * leading zero survives. This schema enforces FORMAT only — the weak-PIN
 * business rule (`000000`, sequential, the employee number itself, D-05) is
 * contextual (needs the employee number) and is enforced by the API layer,
 * which returns `WEAK_PIN` on rejection. See the README "Ambiguity
 * resolutions" section.
 */
export const PinSchema = z.string().regex(/^\d{6}$/, 'PIN must be exactly 6 digits');
//# sourceMappingURL=pin.js.map